import React from 'react'
import { ProductCardSkeleton } from '@sainsburys-tech/bolt'
import * as Styled from './styles'

const productClassName = 'xs-block md-row xs-12 sm-6 md-4'
const ProductListSkeleton = () => (
  <Styled.ProductList className='xs-block sm-row xs-12 lg-9'>
    <Styled.SkeletonWrapper className={productClassName}>
      <ProductCardSkeleton />
    </Styled.SkeletonWrapper>
    <Styled.SkeletonWrapper className={productClassName}>
      <ProductCardSkeleton />
    </Styled.SkeletonWrapper>
    <Styled.SkeletonWrapper className={productClassName}>
      <ProductCardSkeleton />
    </Styled.SkeletonWrapper>
    <Styled.SkeletonWrapper className={productClassName}>
      <ProductCardSkeleton />
    </Styled.SkeletonWrapper>
    <Styled.SkeletonWrapper className={productClassName}>
      <ProductCardSkeleton />
    </Styled.SkeletonWrapper>
    <Styled.SkeletonWrapper className={productClassName}>
      <ProductCardSkeleton />
    </Styled.SkeletonWrapper>
  </Styled.ProductList>
)
export default ProductListSkeleton
